import React, { Component } from 'react'
// import Tick from '../images/tick.svg'

const Tick = (props) =>(
    <svg xmlns="http://www.w3.org/2000/svg" fill={props.fill} width="15px" height="15px" viewBox="0 0 3.94 2.55">
        <g id="Layer_x0020_1">
            <path d="M0.63 0.76c-0.14,-0.14 -0.38,-0.14 -0.52,0 -0.14,0.14 -0.14,0.38 0,0.52l1.09 1.09c0.12,0.12 0.29,0.19 0.45,0.19 0.16,0 0.32,-0.06 0.45,-0.19l1.74 -1.74c0.14,-0.14 0.14,-0.38 0,-0.52 -0.14,-0.14 -0.38,-0.14 -0.52,0l-1.67 1.67 -1.02 -1.02z"/>
        </g>
    </svg>
)

export default class SelectLangItem extends Component {

    itemClick(){
        this.props.onSelectLang(this.props.id,this.props.title,this.props.index,this.props.tag,this.props.direction)
    }

    render() {
        return (
            <div onClick={this.itemClick.bind(this)} className="selectLangItem" style={{color:this.props.selected?'var(--brown1)':'var(--gray3)',borderBottom:this.props.index<this.props.totalCount-1?'1px solid var(--gray3)':'0px'}}>
                {this.props.title}
                <div>
                    {this.props.selected && <Tick fill='var(--brown1)'/>}
                </div>
            </div>
        )
    }
}
